export const SCREENS = {
  TITLE: 'Title',
  LEVEL: 'Level',
  LOSE: 'Lose',
  WIN: 'Win',
  CHARACTER_SELECT: 'CharacterSelect',
  MODE_SELECT: 'ModeSelect',
}